document.addEventListener("DOMContentLoaded", function (event) {
  // <-- add this wrapper
  var element = document.querySelectorAll(".search-icon");

  if (element) {
    element.forEach(function (el, key) {
      el.addEventListener("click", function () {
        console.log(key);
        var parent = el.closest(".search-icon-wrapper");

        parent.classList.toggle("active");

        element.forEach(function (ell, els) {
          if (key !== els) {
            var parent = ell.closest(".search-icon-wrapper");
            parent.classList.remove("active");
          }
          console.log(els);
        });
      });
    });
  }
});

(function ($, Drupal, drupalSettings) {
  "use strict";

  /**
   * jQuery Superfish plugin.
   *
   * @type {Drupal~behavior}
   *
   * @prop {Drupal~behaviorAttach} attach
   *   Attaches the behavior to an applicable <ul> element.
   */
  Drupal.behaviors.star = {
    attach: function (context, drupalSettings) {
      if (typeof context["location"] !== "undefined") {
        // Only fire on document load.

        // Take a look at each menu to apply Superfish to.
        $(document).on("click", ".sf-return", function () {
          $(this)
            .closest(".sf-depth-1")
            .removeClass("active-trail")
            .removeClass("sf-expanded");
          $(this)
            .closest(".sf-depth-1 > ul")
            .addClass("sf-hidden")
            .css("display", "");
        });
        $(window).on("load", function () {
          $("#superfish-main-accordion .sf-depth-2")
            .find("a.menuparent,span.nolink.menuparent")
            .first()
            .each(function () {
              if ($(this).closest("li").children("ul")) {
                $(this)
                  .closest("ul")
                  .append('<span class="sf-return"> < </span>');
                  $(this)
                  .closest("ul")
                  .prepend('<span class="sf-return"> < </span>');
              }
            });
          // $("#superfish-main-accordion .sf-depth-2")
          //   .find("a.menuparent,span.nolink.menuparent")
          //   .last()
          //   .each(function () {
          //     if ($(this).closest("li").children("ul span:not(.first-bar)")) {
          //       $(this)
          //         .append('<li><span class="sf-return"> < </span></li>');
          //     }
          //   });
        });
      }
    },
  };
})(jQuery, Drupal, drupalSettings);
